import { Dispatch, SetStateAction } from "react";

export default function MediaFileInput({ setData }: { setData: Dispatch<SetStateAction<any>> }) {
  return <input type="file" accept="image/*" multiple onChange={(e) => setData(e.target.files)} />;
}
